<div id="chartdiv_{{goalIndex + '_' + subThemeIndex}}" style="width: 100%; height: 100%">

</div>
